<template>
    <div class="public-intro">
        <div class="public-intro-top">
            <div class="public-intro-top-logo">
                <img v-if=" ! openEntryLogo" src="@/assets/img/footer-resvana.png" width="120">
                <img v-if="openEntryLogo" :src="$imgUrl(openEntryLogo)">
            </div>
            <div class="public-intro-top-close" v-if="index !== 0 || steps.length === 2" @click="skip()">
                <img src="@/assets/img/clear.png" width="20">
            </div>
        </div>

        <div class="public-intro-container">
            <v-alert class="mb-6" type="error" :icon="false" v-if="error" v-html="error" />

            <div class="public-intro-container-step" v-show="steps[index] === 1">
                <h1 class="public-intro-container-step-title" v-html="__('public_entry_step_1_title', 'Hej!')"></h1>
                <p class="public-intro-container-step-subtitle" v-html="__('public_entry_step_1_paragraph', 'Genom att fylla i några enkla uppgifter får du en extra skjuts i vår tjänst!')"></p>

                <h3 class="public-intro-container-step-label mt-10">Välj region</h3>

                <div
                    class="public-intro-container-step-btn"
                    v-for="client in filteredClients"
                    :key="client.id"
                    @click="setClientId(client.id)"
                    :class="{chosen: client.id === clientId}"
                >
                    {{ client.title }}
                </div>
            </div>

            <div class="public-intro-container-step" v-show="steps[index] === 2">
                <template v-if=" ! openEntryContent">
                    <p class="public-intro-container-step-title-2">Mellan vilka destinationer reser du som mest i vardagen?</p>
                    <p class="public-intro-container-step-small"><em>T. ex. mellan hemmet och arbetsplatsen eller mellan skolan och fotbollsplanen.</em></p>
                </template>

                <template v-else>
                    <div v-html="openEntryContent"></div>
                </template>

                <template v-if=" ! noFromAddress">
                    <h3 class="public-intro-container-step-label mt-6 mb-1">Från</h3>
                    <v-text-field :height="10" :error="errorAttribute === 'from'" hide-details placeholder="Skriv in en adress" ref="from" v-model="from" outlined></v-text-field>
                </template>

                <h3 class="public-intro-container-step-label mt-4 mb-1">Till</h3>
                <v-text-field :height="10" hide-details placeholder="Skriv in en adress" ref="to" v-model="to" outlined></v-text-field>
            </div>

            <div class="public-intro-container-step" v-show="steps[index] === 3">
                <p class="public-intro-container-step-title-2 mb-7" v-html="openEntryStep2Title || 'Hur tar du dig oftast dit?'"></p>

                <div
                    class="public-intro-container-step-btn flexible"
                    v-for="modeOfTransport in modesOfTransport"
                    :key="modeOfTransport.title"
                    :style="modeOfTransportStyle(modeOfTransport)"
                    @click="setModeOfTransport(modeOfTransport)"
                    :class="{chosen: modeOfTransport.title === transport}"
                >
                    <i :class="modeOfTransport.icon"></i>
                    {{ modeOfTransport.title }}
                </div>

                <template v-if=" ! noFirstname">
                    <p class="public-intro-container-step-title-2 mt-7">Vad heter du i förnamn?</p>
                    <v-text-field :height="10" :error="errorAttribute === 'firstName'" hide-details placeholder="Ditt förnamn" v-model="firstName" outlined></v-text-field>
                </template>
            </div>

            <div class="public-intro-container-steps">
                <div class="public-intro-container-steps-prev" :class="{disabled: index === 0}" @click="prevStep()">
                    <img src="@/assets/img/chevron-left.png" alt="">
                </div>
                <div class="public-intro-container-steps-page">Sida {{ index + 1 }} / {{ steps.length }}</div>
                <div class="public-intro-container-steps-next" @click="nextStep()">{{ openEntryButtonText || 'Nästa' }}</div>
            </div>

            <div class="public-intro-container-gdpr" v-if="openEntryGdpr" v-html="openEntryGdpr"></div>
        </div>

        <img class="public-intro-mobile-image" src="@/assets/img/prestep-illustration-mobile.jpg" alt="">

        <div class="public-intro-bottom-logos">
            <div>
                <h3 v-html="__('footer_bottom_service', 'Tjänsten')"></h3>
                <a href="https://resvana.com" target="_blank">
                    <img class="resvana-logo" src="@/assets/img/footer-resvana.png" width="115">
                </a>
            </div>

            <div>
                <h3 v-html="__('footer_bottom_delivered_by', 'Levereras av')"></h3>
                <a href="https://nudgd.se" target="_blank">
                    <img class="resvana-logo" src="@/assets/img/footer-nudgd.png" width="100">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'PublicIntro',
    props: ['clients'],

    data() {
        return {
            index: 0,
            steps: [1, 2, 3],
            error: null,
            errorAttribute: null,
            currentClient: null,

            clientId: null,
            transport: null,
            firstName: null,
            to: null,
            from: null,
            fromObject: {},

            modesOfTransport: [
                {title: 'Promenad', icon: 'icon-walking', color: '#27A228'},
                {title: 'Cykel', icon: 'icon-bicycle', color: '#00a9ce'},
                {title: 'Kollektivtrafik', icon: 'icon-tram', color: '#ff671f'},
                {title: 'Bil', icon: 'icon-car', color: '#2237AF'},
                {title: 'Annat', icon: null, color: '#d02d9e'},
            ]
        }
    },

    mounted() {
        // If previous open end user exists in the cookie, redirect
        if (this.$getCookie('openEndUser') && this.$getCookie('openEndUserHost') == window.location.host) {
            this.$router.push({name: 'EndUser', params: {slug: this.$getCookie('openEndUser')}})
            return
        }

        // Setup autocomplete
        if (this.$store.state.mapsApi) {
            let options = {componentRestrictions: {country: 'se'}}
            let autoComplete1 = new this.$store.state.mapsApi.maps.places.Autocomplete(this.$refs.from.$el.querySelector('input'), options)
            let autoComplete2 = new this.$store.state.mapsApi.maps.places.Autocomplete(this.$refs.to.$el.querySelector('input'), options)

            autoComplete1.addListener('place_changed', () => {
                this.$store.state.mapPreserveViewport = true
                this.$store.state.directions.from = autoComplete1.getPlace().formatted_address

                let route = this.$oc(autoComplete1.getPlace().address_components.find(a => a.types.includes('route')), 'long_name')
                let streetNr = this.$oc(autoComplete1.getPlace().address_components.find(a => a.types.includes('street_number')), 'long_name')
                let postalTown = this.$oc(autoComplete1.getPlace().address_components.find(a => a.types.includes('postal_town')), 'long_name')
                let postalCode = this.$oc(autoComplete1.getPlace().address_components.find(a => a.types.includes('postal_code')), 'long_name')

                this.fromObject = {
                    address: (route + ' ' + (streetNr || '')).trim(),
                    city: postalTown,
                    zip: postalCode
                }
            })

            autoComplete2.addListener('place_changed', () => {
                this.$store.state.mapPreserveViewport = true
                this.$store.state.directions.to = autoComplete2.getPlace().formatted_address
                this.$store.state.toFromIntro = autoComplete2.getPlace().formatted_address
                this.$store.state.hasChangedTo = true
                this.$setCookie('toDestination', this.$store.state.directions.to)
            })
        }

        // Remove step #1 if we already have a client
        this.currentClient = this.clients?.find(c => {
            // Split comma-separated list
            if (c.campaign_url.includes(',')) {
                return c.campaign_url.split(',').includes(window.location.host)
            } else {
                return c.campaign_url === window.location.host
            }
        })

        // For testing purposes
        //this.currentClient = this.clients.find(c => c.id == 4)
        //this.currentClient = this.clients.find(c => c.campaign_url === 'lstuppsala.resvana.com')

        // If Skip Open Entry, create end user instantly, and redirect into app
        if (this.currentClient && this.currentClient.skip_open_entry) {
            this.clientId = this.currentClient.id
            this.finish()
        }

        if (this.currentClient) {
            this.steps = [2, 3]
            this.clientId = this.currentClient.id

            this.$event({event_type_id: 22, value: 'Arrived at open entry', client_id: this.clientId})
        }
    },

    methods: {
        modeOfTransportStyle(modeOfTransport) {
            if (this.transport === modeOfTransport.title) {
                return {'background-color': modeOfTransport.color, 'border-color': modeOfTransport.color, 'color': '#fff'}
            }
        },

        nextStep() {
            this.error = null

            if (this.steps[this.index] === 1) {
                if (this.clientId === null) {
                    return alert('Du måste välja en region')
                }

                this.$event({event_type_id: 22, value: 'Arrived at public entry', client_id: this.clientId})
            }

            if (this.steps[this.index] === 2) {
                this.$event({event_type_id: 22, value: 'Completed first step', client_id: this.clientId})
            }

            if (this.steps[this.index] === 3) {
                this.$event({event_type_id: 22, value: 'Completed second step', client_id: this.clientId})
            }

            // Step logic
            if (this.index < this.steps.length - 1) {
                this.currentClient = this.clients?.find(c => c.id === this.clientId)
                this.index++
            } else {
                this.finish()
            }
        },

        prevStep() {
            this.errorAttribute = null
            this.error = null

            this.index--

            if (this.index === 0 && this.steps.length > 2) {
                this.currentClient = null
            }
        },

        setClientId(clientId) {
            this.clientId = clientId
        },

        setModeOfTransport(transport) {
            this.transport = transport.title
            this.$store.state.transportPreference = transport.title
        },

        skip() {
            this.$event({event_type_id: 22, value: 'Clicked skip', client_id: this.clientId})

            this.finish()
        },

        finish() {
            this.$store.state.loading = true

            // Create end user
            let endUser = {
                first_name: this.firstName,
                client_id: this.clientId,
                address: this.fromObject.address,
                zip: this.fromObject.zip,
                city: this.fromObject.city
            }

            axios.post(this.$apiUrl + '/api/intro/create-end-user', endUser).then(res => {
                // Go to End User & Set Cookie
                this.$setCookie('openEndUser', res.data.slug, 365)
                this.$setCookie('openEndUserHost', window.location.host, 365)
                this.$router.push({name: 'EndUser', params: {slug: res.data.slug}, query: this.$route.query})
            })
        }
    },

    computed: {
        filteredClients() {
            return this.clients.filter(c => c.region_on_public_prestep)
        },

        openEntryContent() {
            return this.$route.query.entry ?
                this.currentClient?.open_entry_content?.variable?.find(v => v.attributes.parameter === this.$route.query.entry)?.attributes.content
                : this.currentClient?.open_entry_content?.default?.content
        },

        openEntryLogo() {
            return this.currentClient?.open_entry_content?.default?.logo || this.currentClient?.logo
        },

        openEntryStep2Title() {
            return this.currentClient?.open_entry_content?.step_2_title
        },

        openEntryButtonText() {
            return this.currentClient?.open_entry_content?.btn_text
        },

        openEntryGdpr() {
            return this.currentClient?.open_entry_content?.gdpr_wysiwyg
        },

        noFirstname() {
            return this.currentClient?.open_entry_content?.dont_ask_for_firstname
        },

        noFromAddress() {
            return this.currentClient?.open_entry_content?.dont_ask_for_from_address
        },
    }
}
</script>
